module.exports = __webpack_public_path__ + "static/img/3.4535047.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/3.jpg
// module id = xyYO
// module chunks = 1